import type { ButtonProps } from "@mui/material";
import { Button } from "@mui/material";
import { useContext } from "react";

import { ampli } from "@/config";
import { FeedContext } from "@/models/FeedContextProvider";
import FileUploadModal from "./FileUploadModal";

export type UploadFileButtonProps = ButtonProps & {
  button?: React.ReactNode;
};

export default function UploadFileButton({ children, button, ...props }: UploadFileButtonProps) {
  const { setFileUploadModal } = useContext(FeedContext);

  const toggleFileUpload = () => {
    ampli.fileUploadInvoke();
    setFileUploadModal((value) => !value);
  };

  return (
    <>
      <FileUploadModal />
      {button ? (
        <span onClick={toggleFileUpload} aria-label="Upload File" {...props}>
          {button}
        </span>
      ) : (
        <Button onClick={toggleFileUpload} aria-label="Upload File" {...props}>
          {children}
        </Button>
      )}
    </>
  );
}
